import { useTranslation } from 'react-i18next'

import { Badge } from '@percent/lemonade'
import { OpportunityStatus } from '@percent/partner-dashboard/services/workplaceGiving/workplaceGivingService.types'
import { OpportunityStatusBadgeProps } from './OpportunityStatusBadge.types'

export function OpportunityStatusBadge({ status }: Readonly<OpportunityStatusBadgeProps>) {
  const { t } = useTranslation()

  switch (status) {
    case OpportunityStatus.DRAFT:
      return <Badge variant="informative">{t('status.draft')}</Badge>
    case OpportunityStatus.ACTIVE:
      return <Badge variant="positive">{t('status.active')}</Badge>
    case OpportunityStatus.CLOSED:
      return <Badge variant="default">{t('status.past')}</Badge>
    case OpportunityStatus.CANCELLED:
      return <Badge variant="critical">{t('status.cancelled')}</Badge>
    default:
      return <Badge variant="positive">{t('status.active')}</Badge>
  }
}
